var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"addNewTypeHeader"},[_c('div',{staticClass:"addNewTypeHeader-saveHolder"},[_c('button-com',{staticClass:"bm-confirm",attrs:{"iconName":"check","iconSize":"small","text":"Save"},nativeOn:{"click":function($event){_vm.save($event)}}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e19f770","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddNewTypeHeader.vue
// module id = SQJa
// module chunks = 0